@for (menuItem of menuItems; track menuItem; let i = $index) {
  <li class="dropdown-menu_item"
    (click)="onMenuItemClick(menuItem)"
    [class.-separator]="menuItem.isSeparator"
    [class.-hover]="i === preselectedMenuItemIndex"
    [class.-is-checked]="menuItem.isChecked"
    #item>
    @if (!menuItem.isSeparator) {
      <span>{{menuItem.label | l10n}}</span>
    } @else {
      <hr />
    }
    @if (menuItem.isChecked) {
      <div class="dropdown-menu_item_icon-wrapper">
        <div class="dropdown-menu_item_selected-icon">
          <svg><use xlink:href="#approve"></use></svg>
        </div>
      </div>
    }
  </li>
}

